<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h5 class="header title">
        <i class="fa fa-cogs"></i><b> Manage Carrier & Document Type Links</b>
      </h5>
    </div>
  </div>

  <div class="row selectpermit">

    <div class="col-md-2 flex-center">
      <label id="idCtype" for="idCtype" class="control-label selectpermittype"
      ><strong>Select CarrierType: </strong></label
    >
    </div>
    <div class="col-md-5 flex-center" style="padding: 0px;">
      <select
      class="form-control"
      id="idCtype"
      [(ngModel)]="selectedCarrierType"
      (change)="onChange()"
    >
      <ng-container *ngFor="let cat of carrierTypes">
        <option [ngValue]="cat" *ngIf="cat.is_active">
          <div>{{ cat.code }} - {{ cat.description }}</div>
        </option>
      </ng-container>
    </select>
    </div>
  </div>
  
  <div class="row">
    <div class="col-md-2 flex-center">
      <label id="idCtype" class="control-label selectpermittype"><strong>Description : </strong></label>
    </div>
    <div class="col-md-5 flex-center" style="padding: 0;">
      <textarea
        class="form-control col-md-4 input-s"
        placeholder="Description"
        [(ngModel)]="description"
      ></textarea>
    </div>
  </div>

  <div class="row">
    <div class="col-12 action">
      <app-actions
        (actionEvent)="doCarrierTypeDocAction($event)"
        [actions]="documentLinkDelinkAction"
      ></app-actions>
    </div>
  </div>

  <div
    class="row"
    style="padding: 20px 0; font-family: 'Open Sans'; font-weight: 600"
  >
    <div class="col-6">
      <strong
        >This left pane shows all the available document types that can still be
        linked to the selected carrier type.
      </strong>
    </div>
    <div class="col-6">
      <strong
        >This right-side pane shows all the document types that are already
        linked and therefore shown on the uploads screen.
      </strong>
    </div>
  </div>

  <div class="row" style="width: 100%; margin: 0">
    <div class="col-6" style="margin: 0px; padding: 0px">
      <div class="row">
        <div class="col-12">
          <div class="tableFixHead">
            <table class="table">
              <thead>
                <th>Select</th>
                <th class="tblhead">Code</th>
                <th class="tblhead">Description</th>
                <!-- <th class="tblhead border-right">Click To Link</th> -->
              </thead>
              <tbody *ngIf="doctypes.unlinked">
                <tr *ngFor="let unlink of doctypes.unlinked; let i as index">
                  <td>
                    <input
                      type="checkbox"
                      value="{{ unlink.id }}"
                      [ngModel]="selectedUnLinkIndex === i"
                      (change)="
                        checkedCarrierDocUnlink(
                          $event,
                          unlink,
                          i
                        )
                      "
                    />
                  </td>
                  <td class="tblbody" style="white-space: nowrap;">
                    {{ unlink.code }}
                  </td>
                  <td class="tblbody">
                    {{ unlink.description }}
                  </td>
                  <!-- <td class="tblbody border-right">
                    <span (click)="OnSaveLinks(unlink.id)" class="btn btn-info btn-sm"><i class="fa fa-pencil fa-fw"
                      aria-hidden="true"></i></span> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6" style="margin: 0px; padding: 0px">
      <div class="row">
        <div class="col-12">
          <div class="tableFixHead">
            <table class="table">
              <thead>
                <th></th>
                <th class="tblhead">Code</th>
                <th class="tblhead">Description</th>
                <th class="tblhead text-center">Mandatory?</th>

                <!-- <th class="tblhead border-right">De-Link</th> -->
              </thead>
              <tbody *ngIf="doctypes.linked">
                <tr *ngFor="let link of doctypes.linked; let i as index">
                  <td>
                    <input
                      type="checkbox"
                      value="{{ link.id }}"
                      [ngModel]="selectedLinkIndex === i"
                      (change)="
                        checkedCarrierDocLink($event, link.id, link, i)
                      "
                    />
                  </td>
                  <td class="tblbody" style="white-space: nowrap;">
                    {{ link.code }}
                  </td>
                  <td class="tblbody">
                    {{ link.description }}
                  </td>
                  <td class="tblbody border-right">
                    <input
                      type="checkbox"
                      [(ngModel)]="link.is_mandatory"
                      (click)="onUpdateLink($event, link.id, link)"
                    />
                  </td>

                  <!-- <td class="tblbody border-right">
                  <span (click)="onDelete(link.id,link.code)" class="btn btn-danger btn-sm"><i class="fa fa-link"
                    aria-hidden="true"></i></span> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-busy
    [message]="message"
    style="z-index: 2000; position: relative"
    *ngIf="isActivated"
  ></app-busy>
  <!-- <div class="col-md-12" >
    <br>
    <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/home']" class="btn btn-md btn-info pull-right" style="width:10%; margin-left:10px; "><i class="fa fa-arrow-circle-left"></i> Back</button>
    <br>
    <br>
    <br>
</div> -->
</div>

<div class="col-md-12">
  <br />
  <div class="cover-x pull-right">
    <div
      class="main-btn rounded-circle rmp-all"
      [routerLink]="['/home']"
      title="Close"
      style="margin: 0px auto !important"
      rel="tooltip"
      data-placement="top"
    >
      <span
        class="fa fa-times fa-2x"
        style="margin: 5.5px auto; color: white !important"
        aria-hidden="true"
      ></span>
    </div>
    <div class="lbl-app" style="margin: 1px auto">
      <span>Close</span>
    </div>
  </div>
  <br />
  <br />
  <br />
</div>
